module.exports = "/_next/static/images/case-tracker-mock-device-d2f2df0b08375a386e929d1c4aad877e.png";